import http from '~/http/index';

export default ({
  state: {
    data: {},
  },

  getters: {
  },

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    async loadData({ commit }) {
      const response = await http.get('v2/Options/GetExchangeOptions');
      commit('SET_DATA', response.data);
    },

    async updateExchangeOptions(__store, data) {
      const response = await http.post('v2/Options/UpdateExchangeOptions', data);
      return response.data;
    },
  },

  namespaced: true,
});
